import { useEffect, useState } from "react";

export function PlatformHandoff() {
  const [message, setMessage] = useState("Opening the association workspace…");

  useEffect(() => {
    const token = new URLSearchParams(window.location.hash.slice(1)).get("t");
    window.history.replaceState(null, "", "/verity-entry");
    if (!token) {
      setMessage("This access link is incomplete. Return to the Verity Connect platform and try again.");
      return;
    }
    void fetch("/api/organizer/platform-handoff", {
      method: "POST",
      credentials: "same-origin",
      headers: { "content-type": "application/json" },
      body: JSON.stringify({ token }),
    }).then(async (response) => {
      const body = await response.json().catch(() => null) as { destination?: string; message?: string } | null;
      if (!response.ok || !body?.destination) throw new Error(body?.message ?? "This access link could not be used.");
      window.location.replace(body.destination);
    }).catch((error: unknown) => {
      setMessage(error instanceof Error ? error.message : "This access link could not be used.");
    });
  }, []);

  return <main className="school-portal-message" aria-live="polite"><h1>Verity Connect</h1><p>{message}</p></main>;
}
